import { type Enum } from '@webapp/utils'

export const PunchOutBillingPreferences = {
  HEADQUARTER_LOCATION: 0,
  SHIPPING_ADDRESS: 1,
} as const

export type PunchOutBillingPreference = Enum<typeof PunchOutBillingPreferences>
